import ProfileImage from 'assets/images/silhouette.jpg';
import {
  AppointmentTypes,
  CurrentUser,
  DirectBookingProviderType,
  DirectBookingSessionType,
} from 'interfaces';

import {directBookingActions} from './directBookingSlice';

export type TProfessionalHeadshot = {
  small: string;
  medium: string;
  large: string;
  full: string;
};

export const mapProviderData = (p?: DirectBookingProviderType) => ({
  userId: p?.userId ?? '',
  providerId: p?.providerId ?? '',
  calendarId: p?.calendarId,
  fullName: p?.providerFullName ?? '',
  bio: p?.introductoryBio ?? '',
  licences: p?.titleProviderPerformingSpecialtyProviderLicenseType ?? [],
  states: p?.state ?? [],
  acceptedInsurances: p?.acceptedInsurance ?? [],
  conditions: p?.conditions ?? [],
  education: p?.educationAndProfessionalTraining ?? '',
  ethnicity: p?.ethnicity ?? [],
  languages: p?.languages ?? [],
  headshot: {
    small: p?.professionalHeadshot?.[0].thumbnails?.small?.url ?? ProfileImage,
    medium: p?.professionalHeadshot?.[0].thumbnails?.large?.url ?? ProfileImage,
    large: p?.professionalHeadshot?.[0].url ?? ProfileImage,
    full: p?.professionalHeadshot?.[0].thumbnails?.small?.url ?? ProfileImage,
  },
  audio: p?.audios?.[0],
  nextAvailable: p?.nextAvailableSlot?.date,
  article: p?.articles?.[0],
});

export const buildBookAppointmentAction = (
  currentUser: CurrentUser,
  selectedSession?: DirectBookingSessionType,
  selectedProvider?: DirectBookingProviderType,
) =>
  selectedSession && selectedProvider
    ? [
        directBookingActions.bookAppointment({
          appointmentDateTimeString: selectedSession.datetime,
          appointmentType: selectedSession.appointmentType as AppointmentTypes,
          appointmentTypeID: selectedSession.appointmentTypeId,
          providerFullName: selectedProvider.providerFullName,
          calendarId: selectedProvider.calendarId,
          providerId: selectedProvider.providerId,
          patientTimezone: selectedSession.timezone,
          patientEmail: currentUser?.email,
          memberFullName: currentUser?.fullName,
        }),
      ]
    : [];

export const normalizePayerName = (payerName?: string): string => {
  if (!payerName) {
    return '';
  }
  if (payerName.toLowerCase().includes('beacon health options')) {
    return 'Carelon Behavioral Health';
  }
  return payerName;
};

export const renormalizePayerName = (payerName?: string): string => {
  if (!payerName) {
    return '';
  }
  if (payerName?.toLowerCase().includes('carelon behavioral health')) {
    return 'Beacon Health Options';
  }
  return payerName;
};
